import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const TopSellerCarousel = () => {
  const [banners, setBanners] = useState([]);

  useEffect(() => {
    const fetchBanners = async () => {
      try {
        const res = await fetch(
          "https://code.gurusport.in/api/site-banner"
        );
        const data = await res.json();
        if (data?.bottom_banner?.data) {
          setBanners(data.bottom_banner.data);
        }
      } catch (error) {
        console.error("Error fetching bottom banners:", error);
      }
    };
    fetchBanners();
  }, []);

  // agar bottom_banner empty hai to section mat dikhana
  if (!banners || banners.length === 0) {
    return null;
  }

  // background images assign
  const banner1 = banners[0]?.banner_image
    ? `https://code.gurusport.in/storage/${banners[0].banner_image}`
    : "";
  const banner2 = banners[1]?.banner_image
    ? `https://code.gurusport.in/storage/${banners[1].banner_image}`
    : "";

  return (
    <section className="py-8 px-3 sm:py-12 sm:px-6 lg:px-8 max-w-7xl mx-auto relative">
      <h2 className="text-lg sm:text-2xl lg:text-3xl font-bold mb-6 sm:mb-12 text-left">
        Fresh & Trending
      </h2>

      {/* Swiper Carousel (kept commented, no change) */}
      {/* <Swiper
        modules={[Navigation, Pagination]}
        pagination={{ clickable: true }}
        spaceBetween={12}
        slidesPerGroup={1}
        className="pb-8"
        breakpoints={{
          0: {
            slidesPerView: 1,
            slidesPerGroup: 1,
          },
          640: {
            slidesPerView: 2,
            slidesPerGroup: 2,
          },
          1024: {
            slidesPerView: 3,
            slidesPerGroup: 3,
          },
          1280: {
            slidesPerView: 4,
            slidesPerGroup: 4,
          },
        }}
      >
        {products.map((product) => (
          <SwiperSlide key={product.id}>
            <div className="bg-white">
              <img
                src={product.image}
                alt={product.name}
                className="w-full aspect-[3/4.8] object-cover"
              />

              <div className="flex w-full overflow-hidden">
                {product.colors.map((color, index) => (
                  <div
                    key={index}
                    className="h-1"
                    style={{
                      backgroundColor: color,
                      width: `${100 / product.colors.length}%`,
                    }}
                  ></div>
                ))}
              </div>

              <div className="mt-2 text-xs sm:text-sm px-1">
                <p className="mb-1 line-clamp-2">{product.name}</p>
                <div>
                  <span className="line-through text-gray-400 mr-2">
                    {product.oldPrice}
                  </span>
                  <span className="font-semibold">{product.price}</span>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper> */}

      {/* Promotional Banners BELOW Carousel */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6 mt-8 sm:mt-12">
        {/* Banner 1 */}
        {banner1 && (
          <div
            className="relative bg-cover bg-center h-[180px] sm:h-[250px] lg:h-[320px] flex items-center justify-start p-4 sm:p-8"
            style={{ backgroundImage: `url(${banner1})` }}
          >
            <div className="max-w-xs text-black">
              {/* Example text if needed */}
            </div>
          </div>
        )}

        {/* Banner 2 */}
        {banner2 && (
          <div
            className="relative bg-cover bg-center h-[180px] sm:h-[250px] lg:h-[320px] flex items-center p-4 sm:p-8"
            style={{ backgroundImage: `url(${banner2})` }}
          >
            <div className="max-w-xs sm:max-w-sm text-black p-3 sm:p-4">
              <p className="text-[10px] sm:text-xs uppercase tracking-wider mb-1 sm:mb-2">
                Design Your Own
              </p>
              <h4 className="text-base sm:text-md lg:text-xl font-semibold mb-2 sm:mb-4 leading-snug">
                Make It Truly Yours <br />
                Where Creativity Meets <br />
                Style & Imagination
              </h4>
              <a
                href="/design-your-own"
                className="text-xs sm:text-sm lg:text-base text-black font-semibold hover:underline flex items-center gap-1"
              >
                Design Now <span>&rarr;</span>
              </a>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default TopSellerCarousel;
